import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useGetEmailLogs } from '@openapi/logs/logs';
import useNotify from '../../hooks/useNotify';
import EmailLogsTable from './components/EmailLogsTable';
import useSorting from '../../hooks/useSorting';
import { TABLE_ROW_COUNT_DEFAULT } from '../../helpers/constants';
import { useAuth } from '../../hooks/useAuth';
import { useTranslation } from 'react-i18next';
import PageWithTitle from '../../components/atom/PageWithTitle';
import { Box, IconButton, Stack, Tooltip } from '@mui/material';
import PreviewIcon from '@mui/icons-material/Preview';
import SearchInput from '../../components/atom/SearchInput';

const EmailLogsPage = () => {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const { user } = useAuth();
    const { notifyError } = useNotify();
    const [{ limit, page }, setParams] = useState({ limit: TABLE_ROW_COUNT_DEFAULT, page: 0 });
    const { sort, sortDir, setSorting } = useSorting(['id', 'DESC']);
    const [search, setSearch] = useState('');
    const {
        data,
        isLoading: loading,
        _error,
        refetch: reloadData,
    } = useGetEmailLogs(
        {
            search,
            limit,
            offset: page * limit,
            sort,
            sortDir,
        },
        {
            query: {
                onError: notifyError,
            },
        },
    );

    return (
        <PageWithTitle
            title={t('emaillogs.title')}
            headline={[
                <Stack
                    key="headline"
                    direction="row"
                    spacing={2}
                    alignItems="center"
                    justifyContent="flex-end"
                    sx={{ width: '100%' }}
                >
                    {user?.isSuperAdmin && (
                        <Tooltip title={t('emaillogs.emailTester')}>
                            <IconButton
                                onClick={() => navigate('/email-tester')}
                                aria-label={t('emaillogs.emailTester')}
                            >
                                <PreviewIcon />
                            </IconButton>
                        </Tooltip>
                    )}
                    <Box sx={{ flex: 1, minWidth: 0 }}>
                        <SearchInput
                            search={search}
                            setSearch={setSearch}
                            setParams={setParams}
                            limit={limit}
                            fullWidth
                        />
                    </Box>
                </Stack>,
            ]}
        >
            <EmailLogsTable
                rows={data?.emaillogs}
                limit={limit}
                page={page}
                setParams={setParams}
                total={data?.total}
                loading={loading}
                sort={sort}
                sortDir={sortDir}
                setSorting={setSorting}
                reloadData={reloadData}
            />
        </PageWithTitle>
    );
};

export default EmailLogsPage;
